<mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="layer-tree">
  <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle>
    <li class="mat-tree-node">
      <button mat-icon-button color="accent" (click)="update(node)">
        <mat-icon *ngIf="node.visible" title="Visibility">check_box</mat-icon>
        <mat-icon *ngIf="!node.visible" title="Visibility">check_box_outline_blank</mat-icon>
      </button>
      <button mat-button>
        {{layerNames[node.name] ? layerNames[node.name] : node.name}}
      </button>
    </li>
  </mat-tree-node>
  <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
    <li>
      <div class="mat-tree-node">
        <button mat-icon-button color="accent" (click)="update(node)">
          <mat-icon *ngIf="node.visible" title="Visibility">check_box</mat-icon>
          <mat-icon *ngIf="!node.visible" title="Visibility">check_box_outline_blank</mat-icon>
        </button>
        <button mat-button matTreeNodeToggle [disabled]="!node.visible">
          {{layerNames[node.name] ? layerNames[node.name] : node.name}}
          <mat-icon class="mat-icon-rtl-mirror">
            {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
          </mat-icon>
        </button>
      </div>
      <ul [class.layer-tree-invisible]="!treeControl.isExpanded(node)">
        <ng-container matTreeNodeOutlet></ng-container>
      </ul>
    </li>
  </mat-nested-tree-node>
</mat-tree>
